import { Request } from "@konv/http";
import { UserStorage } from "../shared/tools/UserStorage";
import { EnvironmentStorage } from "../shared/tools/EnvironmentStorage";

export class OrdersAPI {
  static async request({
    endpoint = "/",
    method = "GET",
    headers,
    query,
    data,
  }) {
    return await Request.request({
      endpoint: endpoint,
      method: method,
      headers: headers,
      service: 'orders',
      ignoreVersion: true,
      params: query,
      data: data
    });
  }

  static async requestAuthenticated({ endpoint = '/', method = 'GET', query, data }) {
    return await OrdersAPI.request({
      endpoint,
      headers: { 'Authorization': 'Bearer ' + UserStorage.getAccessToken() },
      method,
      query,
      data,
    });
  }

  static async getOrders({
    page,
    limit,
    term,
    begin,
    end,
    canceled,
    rejected,
  }) {
    const searchQuery = Object.fromEntries(
      Object.entries({ page, limit, term, begin, end, canceled, rejected }).filter(([_, value]) => value)
    );
    
    return await OrdersAPI.requestAuthenticated({
      endpoint: `/environments/${EnvironmentStorage.getSelectedEnvironment()}`,
      method: "GET",
      query: searchQuery,
    });
  }
}
